import { z } from "zod";

import {
  PatchVariationDtoSchema,
  VariationDtoSchema,
} from "../../../dtos/variations";

export const PatchVariationsRequestBodySchema = z.object({
  variations: PatchVariationDtoSchema.array(),
});

export type PatchVariationsRequestBodyType = z.infer<
  typeof PatchVariationsRequestBodySchema
>;

export const PatchVariationsResponseBodySchema = z.object({
  variations: VariationDtoSchema.array(),
});

export type PatchVariationsResponseBodyType = z.infer<
  typeof PatchVariationsResponseBodySchema
>;
